'use client';

import React, { useEffect } from 'react';

type ImageKey = 'story_1' | 'story_2' | 'story_3' | 'story_4' | 'story_5' | 'story_6';

const Story = () => {
  const [imageLoadStates, setImageLoadStates] = React.useState<Record<ImageKey, boolean>>({
    story_1: false,
    story_2: false,
    story_3: false,
    story_4: false,
    story_5: false,
    story_6: false,
  });

  const handleImageLoad = (imageKey: string) => {
    console.log(`Image loaded: ${imageKey}`);
    setImageLoadStates((prev) => ({ ...prev, [imageKey]: true }));
  };

  const handleImageError = (imageKey: string) => {
    console.log(`Image error: ${imageKey}`);
    // 에러가 발생해도 스켈레톤을 숨기고 이미지를 표시
    setImageLoadStates((prev) => ({ ...prev, [imageKey]: true }));
  };

  const imageConfigs: { key: ImageKey; src: string; height: number }[] = [
    { key: 'story_1', src: 'https://cdn.kottonseed.io/assets/main/story/story_1.webp', height: 688 },
    { key: 'story_2', src: 'https://cdn.kottonseed.io/assets/main/story/story_2.webp', height: 1038 },
    { key: 'story_3', src: 'https://cdn.kottonseed.io/assets/main/story/story_3.webp', height: 753 },
    { key: 'story_4', src: 'https://cdn.kottonseed.io/assets/main/story/story_4.webp', height: 4866 },
    { key: 'story_5', src: 'https://cdn.kottonseed.io/assets/main/story/story_5.webp', height: 842 },
    { key: 'story_6', src: 'https://cdn.kottonseed.io/assets/main/story/story_6.webp', height: 924 },
  ];

  // 이미지가 이미 캐시되어 있는 경우를 위한 처리
  useEffect(() => {
    const checkImageCache = async () => {
      const promises = imageConfigs.map(({ key, src }) => {
        return new Promise<{ key: string; loaded: boolean }>((resolve) => {
          const img = new Image();
          img.onload = () => resolve({ key, loaded: true });
          img.onerror = () => resolve({ key, loaded: false });
          img.src = src;
        });
      });

      const results = await Promise.all(promises);
      const newStates = { ...imageLoadStates } as Record<ImageKey, boolean>;

      results.forEach(({ key, loaded }) => {
        if (loaded) {
          console.log(`Image from cache: ${key}`);
          newStates[key as ImageKey] = true;
        }
      });

      setImageLoadStates(newStates);
    };

    checkImageCache();
  }, []);

  return (
    <div className="relative">
      {imageConfigs.map(({ key, src, height }) => (
        <div key={key} className="relative h-full w-full">
          {!imageLoadStates[key] && (
            <div className="shimmer w-full animate-shimmer" style={{ height: `${height}px` }} />
          )}
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={src}
            alt={key}
            onLoad={() => handleImageLoad(key)}
            onError={() => handleImageError(key)}
            className="h-full w-full object-cover"
            style={{
              opacity: imageLoadStates[key] ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out',
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default Story;
